// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"filter-clear"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M19.5 4H4.5L10.5 12.5V20H13.5V12.5L19.5 4Z","fill-rule":"evenodd","clip-rule":"evenodd"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M19.5 4H4.5L10.5 12.5V20H13.5V12.5L19.5 4Z","fill-rule":"evenodd","stroke-linecap":"square","stroke-width":2,"clip-rule":"evenodd"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M22.1215 14.8789L20.0002 17.0002M20.0002 17.0002L17.8789 19.1215M20.0002 17.0002L17.8789 14.8789M20.0002 17.0002L22.1215 19.1215","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-filter-clear')
export default class FilterClearIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'filter-clear',
    }
  }
}
